module.exports = __webpack_public_path__ + "fonts/fa-regular-400.154b0e1.woff2";